export default __webpack_public_path__ + "static/media/217.f32d84a3.png";